export { default } from './ThemeProvider';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/styles/esm/ThemeProvider/index.js
// module id = 628
// module chunks = 0